import { FC } from "react";

import { Stack } from "@mui/material";

import type { NavigationNotice } from "./helpers/useNavigationAction";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import { DashboardTypography } from "@/dashboard-design-system/Typography";
import { ArrowRight } from "@/icons/outlined";

interface NavigationButtonProps {
  label: string;
  isLoading?: boolean;
  notice?: NavigationNotice | null;
  onClick: (() => void) | (() => Promise<void>);
}

export const NavigationButton: FC<NavigationButtonProps> = ({ label, isLoading = false, notice = null, onClick }) => {
  const { t } = useTranslate();
  const notices: Record<NavigationNotice, string> = {
    identityProcessing: t("dashboard", "organizationAssistant.navigation.identityProcessing"),
    error: t("dashboard", "organizationAssistant.navigation.error"),
  };
  return (
    <Stack spacing={1} alignItems="flex-start">
      <DashboardButton
        variant="outlined"
        size="small"
        endIcon={<ArrowRight />}
        isLoading={isLoading}
        onClick={onClick}
        data-test="organization-assistant-navigation-button"
      >
        {label}
      </DashboardButton>
      {notice && (
        <DashboardTypography
          role={notice === "error" ? "alert" : "status"}
          variant="caption"
          vibe={notice === "error" ? "text-danger-moderate" : "text-neutral-moderate"}
        >
          {notices[notice]}
        </DashboardTypography>
      )}
    </Stack>
  );
};
